const Form058TC = {
    stepName: {
        information: "基本資料",
        partA: "甲部",
        partB: "乙部",
        certification: "聲明",
        confirm: "確認",
    },
    labelStep: [
        { step: "（a）" },
        { step: "（b）" },
        { step: "（c）" },
        { step: "（d）" },
        { step: "（e）" },
        { step: "（f）" },
    ],
    notes: {
        agreeTips: "我已閱讀、理解並同意上述條款和條件。",
        items1: "（有關必須向強積金供款的代課教師，如申領津貼期少於60天，請提供強積金供款的資料證明）",
        items2: "有關詳情請參閱「整合代課教師津貼在設有法團校董會的資助學校於調整班級數目後的修訂」。在「自願優化班級結構」計劃的保留期內，資助中學的過剩教席須按下列先後次序抵銷：（a）小數位教師職位；（b）高中課程支援津貼；以及（c）代課教師，詳情請參閱教育局通函第190／2010號第4及5段。",
        tips1: "特殊教育教師專業發展課程包括：",
        "(a)": "（a）30小時「照顧不同學習需要」基礎課程（5天）<b><u>（只適用於2021年4月30日或以前完成課程的申請）</b></u>",
        "(b)": "（b）102小時「照顧不同學習需要」高級課程（17天）<b><u>（只適用於2021年4月30日或以前完成課程的申請）</b></u>",
        "(c)": "（c）90／120小時「支援有特殊教育需要學生」專題課程（15／20天）<b><u>（只適用於2021年4月30日或以前完成課程的申請）</b></u>",
        "(d)": "（d）72小時「照顧不同學習需要」高級課程（12天）",
        "(e)": "（e）60／72小時「支援有特殊教育需要學生」專題課程（10／12天）",
        "(f)": "（f）240小時 特殊學校教師培訓課程－第一部分（40天）（不包括第二部分為期六個月的實習）",
        "(g)": "（g）18小時 在學校推廣精神健康及支援有精神健康需要的學生初級培訓（3天）<b><u>（只適用於2021年3月30日或以前完成課程的申請）</b></u>",
        "(h)": "（h）30小時 在學校推廣精神健康及支援有精神健康需要的學生深造培訓（5天）<b><u>（只適用於2021年3月30日或以前完成課程的申請）</b></u>",
        "(i)": "（i）42小時 支援大腦性視障學童的學習需要課程（6天）",
        "(j)": "（j）49小時 支援眼球性視障學童的學習需要課程（7天）",
        "(k)": "（k）117小時 特殊教育需要統籌主任專業發展課程（18天）",
        tips2: "學校必須按照教育局通告第1／2006號的規定批假。",
        tips3: "請填寫休假教師的職員參考編號。",
        tips4: "請以註1所列的英文字母標明參加的課程。",
        tips5: "工作日數不應包括星期日、星期六（短周）、公眾假期、由學校自行訂定的假期或教師毋須執行職務的任何周日。",
        tips6: "有關資助學校代課教師當時適用的日薪率，請參閱相關的教育局通函。",
        tips7: "如代課期少於60個曆日，但代課教師須向強積金供款，請提供證明資料。",
        terms1: "有關薪酬已付予代課教師及／或強積金計劃的受托人，現附上有關收據，以供記錄存檔；",
        terms2: "上述申請不在整合代課教師津貼涵蓋範圍；",
        // terms3HasNo:
        //     "本校並<b>沒有過剩教師</b>，而在聘請任何代課教師前，過剩教師數目已經抵銷＃",
        terms3Item1: "本校",
        terms3ItemNo: "並",
        terms3Item2: "過剩教師",
        terms3ItemHas: "名",
        terms3Item3: "，而在聘請任何代課教師前，過剩教師數目已經抵銷",
        terms3End: "；以及",
        terms4: "本校沒有就上述假期/空缺向政府提出其他津貼的申請，例如把以現金津貼取代額外英語教師職位及把小數位教師職位轉為小數位職位現金津貼。",
        terms5: "學校已查核代課教師的教師註冊文件，以及徵得他們的同意，向教育局申請發放其教師註冊資料。",
        terms6: "本校會把政府多付的津貼退還政府。",
        termsTips1: "申請人應仔細閱讀並同意",
        termsTips2: "隱私數據的註意事項",
    },
    serial: {
        tips: {
            num1: "（ⅰ）",
            num2: "（ⅱ）",
            num3: "（ⅲ）",
            num4: "（iv）",
            num5: "(v)",
        },
    },
    label: {
        basicOption: {
            note: "註",
        },
        informationOption: {
            items: "註意事項：",
            terms: "條款和條件",
            title: "學校資料",
            formType: "新/修訂表格",
            changePreClaim: "不更改先前聲明／刪除先前聲明／更改先前聲明",
            preClaimNum: "請註明前次申領的申請編號",
            applicationNum: "申請編號",
            previousDate: "前次申領表格日期",
            previousFormFile: "前次申領表格副本",
            schoolName: "學校名稱",
            schoolCode: "學校代碼",
            month: "月份",
            year: "年份",
        },
        partAOption: {
            title1: "<u>甲部</u> 發還因教師參加被教育局認可的特殊教育教師專業發展課程",
            title2: "而聘任合資格代課教師所支付的薪金及強積金計劃僱主供款",
            teacherOnLeave: "休假教師",
            name: "姓名",
            srn: "職員參考編號",
            courseAttended: "課程",
            post: "職位",
            leavePeriodForm: "休假日期由",
            leavePeriodTo: "休假日期至",
            supplyTearchName: "代課教師姓名",
            supplyPeriodFrom: "代課日期由",
            supplyPeriodTo: "代課日期至",
            workingDays: "工作日數（a）",
            dailyRate: "日薪率（b）",
            salaryAmount: "薪金總額（a）×（b）",
            mpfSubsidy: "強積金供款津貼（c）",
            contractPeriodFrom: "合約期由",
            contractPeriodTo: "合約期至",
            leavePeriod: "休假日期",
            contractPeriod: "合約期",
            amountUnit: "元",
            salaryAmountTotal: "總額（薪金總額）",
            mpfSubsidyTotal: "總額（強積金供款津貼）",
            salaryAmountFile: "附上已付予代課教師及／或強積金計劃的受託人收據",
            mpfSubsidyFile: "強積金供款副本",
        },
        partBOption: {
            title: "<u>乙部</u> 有關以月薪聘任的臨時教師，請遞交教育局網頁內的聘任表格",
            govUrl: "https://www.edb.gov.hk",
            itemStep1: "學校行政及管理",
            itemStep2: "一般行政",
            itemStep3: "有關學校教職員",
            itemStep4: "聘任事宜",
        },
        certificationOption: {
            title: "<u>丙部</u> 認證",
            noteTitle: "本人證實—",
            surplusTeachers: "過剩教師",
            teacherNumber: "過剩教師人數",
            claimDate: "申請日期",
            contactPerson: "聯絡人",
            telNo: "電話號碼",
            ssdo: "副本送︰高級學校發展主任",
        },
    },
    select: {
        courseOption: {
            "(a)": "（a）30小時「照顧不同學習需要」基礎課程（5天）{{bolderText}}",
            "(b)": "（b）102小時「照顧不同學習需要」高級課程（17天）{{bolderText}}",
            "(c)": "（c）90／120小時「支援有特殊教育需要學生」專題課程（15／20天）{{bolderText}}",
            "(d)": "（d）72小時「照顧不同學習需要」高級課程（12天）",
            "(e)": "（e）60／72小時「支援有特殊教育需要學生」專題課程（10／12天）",
            "(f)": "（f）240小時 特殊學校教師培訓課程－第一部分（40天）（不包括第二部分為期六個月的實習）",
            "(g)": "（g）18小時 在學校推廣精神健康及支援有精神健康需要的學生初級培訓（3天）{{bolderText}}",
            "(h)": "（h）30小時 在學校推廣精神健康及支援有精神健康需要的學生深造培訓（5天）{{bolderText}}",
            "(i)": "（i）42小時 支援大腦性視障學童的學習需要課程（6天）",
            "(j)": "（j）49小時 支援眼球性視障學童的學習需要課程（7天）",
            "(k)": "（k）117小時 特殊教育需要統籌主任專業發展課程（18天）",
        },
        courseOptionBolder: {
            "(a)": "（只適用於2021年4月30日或以前完成課程的申請）",
            "(b)": "（只適用於2021年4月30日或以前完成課程的申請）",
            "(c)": "（只適用於2021年4月30日或以前完成課程的申請）",
            "(g)": "（只適用於2021年3月30日或以前完成課程的申請）",
            "(h)": "（只適用於2021年3月30日或以前完成課程的申請）",
        },
        formTypeOption: {
            new: "新表格",
            revised: "修訂表格",
        },
        changePreClaimOption: {
            unchange: "不更改先前聲明",
            delete: "刪除先前聲明",
            change: "更改先前聲明",
        },
        surplusTeachersOption: {
            Yes: "有",
            No: "沒有",
        },
    },
    errorMsg: {
        required: "此項必須填寫",
        lengthMax: "該字段最多只允許{{max}}個字符",
        maxDecimal: "此項必須為小數後最多2位",
        maxOneDecimal: "此項必須為小數後最多1位",
        validPrice: "請輸入一個有效的價格",
        numberMax: "此項必須為最多{{number}}位",
        telMax: "電話號碼必須為最多12位數",
        numberUnit: "該字段必須最小單位為0.5",
        acdamicYear: "請選擇同一學年範圍內的{{fildName}}",
        courseWorkingDays: "工作日數不能超過參加課程中規定的天數",
        supplyPeriodWorkingDays: "工作日數不能超過代課日期所選範圍的天數",
    },
};
export default Form058TC;
